import './Pagination.css';
import { usePagination } from '../hooks/usePagination';

export default function Pagination({ page, totalPages, total, pageSize, onPageChange, label = 'items' }) {
  if (!total || total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="list-pagination">
      <span className="list-pagination-info">
        {from}–{to} of {total} {label}
      </span>
      <div className="list-pagination-controls">
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <span>Page {page} of {totalPages}</span>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export function PagedSlice({ items, pageSize = 10, label = 'items', resetKey, children }) {
  const list = items || [];
  const pages = usePagination(list, pageSize, resetKey ?? list.length);
  return (
    <>
      {children(pages.pageItems)}
      <Pagination
        page={pages.page}
        totalPages={pages.totalPages}
        total={pages.total}
        pageSize={pages.pageSize}
        onPageChange={pages.setPage}
        label={label}
      />
    </>
  );
}
